export const handleLoading = state => {
  state.loading = true
};
export const handleStopLoading = state => {
  state.loading = false
};
export const handleFail = (state, action) => {
  state.error = action.payload
};
export const handleErrorStopLoading = (state, action) => {
  state.loading = false;
  state.error = action.error;
}